webpackJsonp([83],{

/***/ 1146:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SlideWithText1.l.scss","sourceRoot":""}]);

// exports


/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1146);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("bca395a2", content, true, {});

/***/ })

});


// WEBPACK FOOTER //
// static/js/83.b35c0b8ddd9bc1380586.js